"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateBinaryExpression = exports.evaluateLogicalExpression = exports.evaluateUnaryExpression = void 0;
const errors_1 = require("./errors");
function evaluateUnaryExpression(operator, value) {
    if (operator === '!') {
        return !value ? 1 : 0;
    }
    else if (operator === '-') {
        return -value;
    }
    else if (operator === '+') {
        return +value;
    }
    return undefined;
}
exports.evaluateUnaryExpression = evaluateUnaryExpression;
function evaluateLogicalExpression(operator, left, right) {
    switch (operator) {
        case '&&':
            return left && right ? 1 : 0;
        case '||':
            return left || right ? 1 : 0;
    }
}
exports.evaluateLogicalExpression = evaluateLogicalExpression;
function evaluateBinaryExpression(command, operator, left, right) {
    switch (operator) {
        case '+':
            return left + right;
        case '-':
            return left - right;
        case '*':
            return left * right;
        case '/':
            if (right == 0) {
                throw new errors_1.DivisionByZeroError(command);
            }
            return left / right;
        case '%':
            if (right == 0) {
                throw new errors_1.DivisionByZeroError(command);
            }
            return left % right;
        case '==':
            return left === right ? 1 : 0;
        case '!=':
            return left !== right ? 1 : 0;
        case '<=':
            return left <= right ? 1 : 0;
        case '<':
            return left < right ? 1 : 0;
        case '>':
            return left > right ? 1 : 0;
        case '>=':
            return left >= right ? 1 : 0;
        case '>>':
            return left >> right;
        case '<<':
            return left << right;
        case '^':
            return left ^ right;
        default:
            throw new errors_1.InterpreterError(command, 'this should have been caught by the parser');
    }
}
exports.evaluateBinaryExpression = evaluateBinaryExpression;
//# sourceMappingURL=operators.js.map